// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"96367e3a","306":"9d952aaa","416":"9903c0ef","538":"7502cfce","545":"4fcaa3e5","566":"c9d68d0f","614":"084c75c7","679":"9104e87f","910":"733bf94a","921":"b9d321ce"}[chunkId] + ".chunk.js";
};